import { locale } from 'dayjs';
// import 'dayjs/locale/fa-IR';
import 'dayjs/locale/en';
import { localStg } from '@/utils/storage';

/**
 * Set dayjs locale
 *
 * @param lang
 */
export function setDayjsLocale(lang: App.I18n.LangType = 'fa-IR') {
  const localMap = {
    'fa-IR': 'fa-ir',
    'en-US': 'en'
  } satisfies Record<App.I18n.LangType, string>;

  const l = lang || localStg.get('lang') || 'fa-IR';

  locale(localMap[l]);
}
